export const LATITUDE_REGEX = /^-?([0-8]?\d(\.\d{1,20})?|90(\.0{1,20})?)$/;
export const LONGITUDE_REGEX = /^-?(1[0-7]\d(\.\d{1,20})?|0?\d{1,2}(\.\d{1,20})?|180(\.0{1,20})?)$/;
